/* global localStorage, $ */

/*
 *   Stores a object to keep track of discarded broadcast messages. 
 *   The messages are hidden by default (they have class hidden).
 *   If they were not discarded before they appear (class hidden is removed).
 */

// Generates a unique hash for the given string.
// We'll store that in the cookie instead of the entire broadcast message.
// Used to see if the message is changed.
var bcastMsgHash = function (s) {
    for (var i = 0, h = 0; i < s.length; i++) {
        h = Math.imul(31, h) + s.charCodeAt(i) | 0;
    }
    return h;
}

// Get our discarded data from bcastdiscard in localStorage
// Gives us an object like { internal: { hash: 1289884333, expires: 123456789876 } }
// Key is message type, value is message hash
var bcastMsgGetDiscarded = function () {
    var discarded = localStorage.getItem("bcastdiscard");
    if (discarded) {
        discarded = JSON.parse(discarded);
    } else {
        discarded = {};
    }
    return discarded;
}

// Action: discard a message
var bcastMsgDiscard = function (msg) {
    var discarded = bcastMsgGetDiscarded();
    var msgHash = bcastMsgHash(msg.text());
    var msgType = msg.data('type');
    var nextMonth = parseInt(Date.now() / 1000 + 60 * 60 * 24 * 30);

    discarded[msgType] = { hash: msgHash, expires: nextMonth };
    localStorage.setItem("bcastdiscard", JSON.stringify(discarded));
    msg.addClass('hidden');
}

// Initialize bcast messages: unhide messages that were not discarded.
var bcastMsgInit = function () { // eslint-disable-line no-unused-vars
    var discarded = bcastMsgGetDiscarded();
    $('.alert.broadcast').each(function () {
        var msg = $(this);
        var msgHash = bcastMsgHash(msg.text());
        var msgType = msg.data('type');
        var now = parseInt(Date.now() / 1000);
        if (discarded[msgType]) {
            var expires = discarded[msgType]['expires'];
            // console.debug(msgType, "expires in", expires - now, "seconds");
            if (discarded[msgType]['hash'] != msgHash || expires < now) {
                msg.removeClass('hidden');
            }
        } else {
            msg.removeClass('hidden');
        }
    });
    $('.alert.broadcast button').on('click', function () {
        bcastMsgDiscard($(this).parent('.broadcast'));
    })
}
